module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAUdJREFUSInlVcFxgzAQ3JXdSCqJ3EEaIONXPK4CqIKRP/GYQhAdpQHYPGQRbAOxnJcn+9JIy+7pjjsBzw7e7NSVpVZ5qpAoDwDIduV431yKu5wyTao4AFAoKBSo3Uxwtct5cpon3IFBo7Jxy9yQrq6YhGxXAvTjFK/jgqIF4Kcjq+x16sR+g2w/zR/h9gbTtNcgikJEcd83SQYAQI9sV6amMMHgMfxrg1D4vxvULqdQDKMA4W8KXfvTUI8ZRHGjI9C3qCsbRPtWRkfKNL+ZrJcOCbwBAHtuAW4vDnXmyHwKeEk24OnQQPgSu81iEFrlPB0avX9M8qYNapdDsqFrl4spyg9TdKIJZ27Qt8DKU7BL4iN4oGvPlnY8TgYDsStD0UIkmht8S6hdHmsTwWsCFd2ZbhCjH6Vq4skMD855fKfJsyvvGeHPhW9cRI3sM07mkQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/25.png
// module id = 2mlK
// module chunks = 1